<template>
  <div class="rules">
    <div class="rules-inner">
      <div class="rule-title">{{ $t('ruleTitle') }}</div>
      <div class="rule-list1">
        <div class="rule-item" v-for="(item, index) in ruleList1" :key="index">
          <div class="rule-num">{{ item.num }}</div>
          <div class="rule-text">{{ item.text }}</div>
        </div>
      </div>
      <div class="reward-table">
        <table>
          <tr>
            <th width="30%" class="bordered">{{ $t('minFunding') }}</th>
            <th width="25%" class="bordered">{{ $t('total') }}</th>
            <th width="45%">{{ $t('gift') }}</th>
          </tr>
          <tr v-for="(item, index) in giftTableData" :key="index">
            <td class="funding-money bordered">{{ item.fundingMoney | formatMoney }}</td>
            <td class="amount align-center bordered">{{ item.amount }}</td>
            <td class="gift align-center">{{ item.gift }}</td>
          </tr>
        </table>
      </div>
      <div class="rule-list2">
        <div class="rule-item" v-for="(item, index) in ruleList2" :key="index">
          <div class="rule-num">{{ item.num }}</div>
          <div class="rule-text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  i18n: {
    messages: {
      en: {
        ruleTitle: 'Syarat & Ketentuan:',
        rule1: 'Event ini berlangsung dari tanggal 15 Januari 2019 pukul 00:00 WIB – 21 Januari 2019 pukul 23:59 WIB',
        rule2: 'Event ini dapat diikuti melalui website (Desktop/Mobile) dan aplikasi Kredit Pintar for Lender terbaru (Android/iOS).',
        rule3: 'Event ini berlaku untuk pengguna baru dan pengguna lama yang telah terdaftar di website/aplikasi Kredit Pintar for Lender.',
        rule4: 'Event ini hanya dapat dilakukan selama periode berlangsung.',
        rule5: 'Event ini dapat diikuti dengan cara melakukan pendanaan selama periode event berlangsung dan sesuai/lebih dari jumlah pendanaan yang telah ditentukan.',
        rule6: 'Setiap pendanaan user akan mendapatkan poin pendanaan. User dapat menukarkan hadiah dengan poin. Cara penghitungan Poin: Jumlah pendanaan* Tenor pendanaan (Hari)/365. Contoh: Jika Anda mendanai 10 juta selama 1 tahun maka poin Anda sebesar 10 juta.',
        rule7: 'Event ini dapat diikuti dengan cara melakukan “Pendanaan Berjangka” dan memilih jangka waktu pendanaan minimal 1 bulan.',
        rule8: 'Poin bersifat akumulatif dimana jika Anda berhasil mengumpulkan poin sebesar 35 juta maka Anda berhak mengambil voucher Xodexo dan voucher MAP.',
        rule9: 'Pengguna yang telah melakukan pendanaan sesuai dengan semua syarat & ketentuan, bisa langsung mendapatkan hadiah tanpa diundi.',
        rule10: 'Kredit Pintar berhak membatalkan hadiah yang diterima pengguna apabila ditemukan adanya indikasi kecurangan, tanpa pemberitahuan terlebih dahulu.',
        rule11: 'Kredit Pintar berhak mengubah syarat dan ketentuan event serta keuntungan yang diterima dari event ini sewaktu-waktu tanpa pemberitahuan terlebih dahulu.',
        rule12: 'Dengan mengikuti promo ini, pengguna dianggap mengerti dan menyetujui semua syarat & ketentuan berlaku.',
        minFunding: 'Pendanaan Minimum',
        total: 'Jumlah',
        gift: 'Hadiah',
      },
      id: {
        ruleTitle: 'Syarat & Ketentuan:',
        rule1: 'Event ini berlangsung dari tanggal 15 Januari 2019 pukul 00:00 WIB – 21 Januari 2019 pukul 23:59 WIB',
        rule2: 'Event ini dapat diikuti melalui website (Desktop/Mobile) dan aplikasi Kredit Pintar for Lender terbaru (Android/iOS).',
        rule3: 'Event ini berlaku untuk pengguna baru dan pengguna lama yang telah terdaftar di website/aplikasi Kredit Pintar for Lender.',
        rule4: 'Event ini hanya dapat dilakukan selama periode berlangsung.',
        rule5: 'Event ini dapat diikuti dengan cara melakukan pendanaan selama periode event berlangsung dan sesuai/lebih dari jumlah pendanaan yang telah ditentukan.',
        rule6: 'Setiap pendanaan user akan mendapatkan poin pendanaan. User dapat menukarkan hadiah dengan poin. Cara penghitungan Poin: Jumlah pendanaan* Tenor pendanaan (Hari)/365. Contoh: Jika Anda mendanai 10 juta selama 1 tahun maka poin Anda sebesar 10 juta.',
        rule7: 'Event ini dapat diikuti dengan cara melakukan “Pendanaan Berjangka” dan memilih jangka waktu pendanaan minimal 1 bulan.',
        rule8: 'Poin bersifat akumulatif dimana jika Anda berhasil mengumpulkan poin sebesar 35 juta maka Anda berhak mengambil voucher Xodexo dan voucher MAP.',
        rule9: 'Pengguna yang telah melakukan pendanaan sesuai dengan semua syarat & ketentuan, bisa langsung mendapatkan hadiah tanpa diundi.',
        rule10: 'Kredit Pintar berhak membatalkan hadiah yang diterima pengguna apabila ditemukan adanya indikasi kecurangan, tanpa pemberitahuan terlebih dahulu.',
        rule11: 'Kredit Pintar berhak mengubah syarat dan ketentuan event serta keuntungan yang diterima dari event ini sewaktu-waktu tanpa pemberitahuan terlebih dahulu.',
        rule12: 'Dengan mengikuti promo ini, pengguna dianggap mengerti dan menyetujui semua syarat & ketentuan berlaku.',
        minFunding: 'Pendanaan Minimum',
        total: 'Jumlah',
        gift: 'Hadiah',
      },
    },
  },
  components: {},
  data() {
    return {
      ruleList1: [
        { num: 1, text: this.$t('rule1') },
        { num: 2, text: this.$t('rule2') },
        { num: 3, text: this.$t('rule3') },
        { num: 4, text: this.$t('rule4') },
        { num: 5, text: this.$t('rule5') },
        { num: 6, text: this.$t('rule6') },
        { num: 7, text: this.$t('rule7') },
      ],
      ruleList2: [
        { num: 8, text: this.$t('rule8') },
        { num: 9, text: this.$t('rule9') },
        { num: 10, text: this.$t('rule10') },
        { num: 11, text: this.$t('rule11') },
        { num: 12, text: this.$t('rule12') },
      ],
      giftTableData: [
        { fundingMoney: 10000000, amount: 1, gift: 'Voucher Xodexo Rp 100.000' },
        { fundingMoney: 35000000, amount: 1, gift: 'Voucher MAP Rp 350.000' },
        { fundingMoney: 150000000, amount: 1, gift: 'Koper Kamiliant' },
        { fundingMoney: 1000000000, amount: 1, gift: 'iPhone X' },
      ],
    }
  },
}
</script>

<style scoped lang="stylus">
.rules
  background-color #3FA328
  color #fff
  padding 18px 16px
  .rules-inner
    border-top 1px solid #fff
    .rule-title
      padding 18px 0
      font-weight bold
    .rule-item
      display flex
      justify-content flex-start
      margin-bottom 10px
      .rule-num {
        display flex
        justify-content center
        align-items center
        min-width 12px
        height 12px
        background-color #fff
        color #5cc414
        border-radius 50%
        font-size 6px
        margin-right 6px
      }
      .rule-text
        font-size: 10px;
        line-height: 12px;
    .reward-table
      border 1px solid #fff
      border-radius 12px
      font-size 8px
      margin 18px 0 18px 15px
      table
        width 100%
      th
        padding 10px
        font-size 10px
        border-bottom 1px solid #fff
      td
        padding 8px

.align-center
  text-align center

.bordered
  border-right 1px solid #fff
</style>
